export const components = {
  // ======== Adjust Properties ========
  Button: {
    'app-packagename': '',
    'app-bundleid': '',
    'app-connect-id': '',
    'group-id': '',
    'public-id': '',
    'guild-id': '',
    'share-type': '27',
    'share-mode': '[\'qq\', \'qzone\']',
    'aria-label': '',
    'open-id': '',
    'share-message-friend-info': '',
    bindAddFriend: '',
    bindAddGroupApp: ''
  }
}
